module.exports = __webpack_public_path__ + "img/qia-logo-sm.5061c17a.png";